import React from 'react';

import { TooltipTextContent } from './common';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function CeilingTrayTooltip(props: { guid: string }) {
  return <TooltipTextContent text="Ceiling Tray" />;
}
